"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultExclusiveProperty = void 0;
exports.defaultExclusiveProperty = {
    propertyId: 406982,
    imageUrl: 'https://www.okay.com/images/home-bg.webp',
    isNoImage: false,
    isSoleAgent: true,
    isJointSoleAgent: false,
    districtName: 'Clearwater Bay',
    buildingName: 'Lobster Bay',
    address: 'Lung Ha Wan Road, Clearwater Bay',
    isSaleSubjectToOffer: false,
    isRentSubjectToOffer: false,
    pricePrefix: 'HK$',
    salePrice: 160000000,
    rentPrice: 0,
    isRentInclusive: null,
    sqft: 4200,
    sqftIsNet: false,
    bedrooms: 5,
    bathrooms: 4,
    link: '/en/property/sale/lobster-bay/406982'
};
